import { render } from "./Pagos-App.vue?vue&type=template&id=81d65ccc&scoped=true"
import script from "./Pagos-App.vue?vue&type=script&lang=js"
export * from "./Pagos-App.vue?vue&type=script&lang=js"

import "./Pagos-App.vue?vue&type=style&index=0&id=81d65ccc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81d65ccc"]])

export default __exports__